module.exports = __webpack_public_path__ + "img/eyeClose.2b11f07e.svg";